import Navbar from "../components/Navbar"
import TextField from "../components/TextField"
import TextArea from "../components/TextArea"
import Button from "../components/Button"
import Footer from "../components/Footer"

async function submitClinic() {

    const fname = document.getElementById("fname").value
    const lname = document.getElementById("lname").value;
    const email = document.getElementById("email").value;
    const clinicName = document.getElementById("clinic-name").value;
    const clinicWebsite = document.getElementById("clinic-website").value;
    const purpose = document.getElementById("purpose").value;
    const languages = document.getElementById("languages").value;
    const eligibility = document.getElementById("eligibility").value;
    const documents = document.getElementById("documents").value;

    const webhookBody = {
        embeds: [{
            title: 'Clinic Registration Form Submitted',
            description: `
            First Name: ${fname}\n
            Last Name: ${lname}\n
            Email: ${email}\n
            Clinic Name: ${clinicName}\n
            Clinic Website: ${clinicWebsite}\n
            Purpose: ${purpose}\n
            Languages Served: ${languages}\n
            Eligibility Requirements: ${eligibility}\n
            Documents Needed: ${documents}
            `
        }]
        }
    
        /* SEND TICKET */
        const webhookURL = "https://discord.com/api/webhooks/1361049640459309246/YRZZJPDmhBm7TkpPBXbhi1Sii8u_3iDz5Trjms6J6mqeCfX8N5-735vFqnvVeG6Hew4q"
        const response = await fetch(webhookURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(webhookBody),
        });
        if (response.ok) {
            alert("We have received your registration! We will email you when your clinic is added to the database.")
            window.location.href = "/";
        } else {
            alert("There was an error submitting your registration form. Please notify admin@kcsocialnest.com.")
            window.location.href = "/";
        }   
}

export default function Register() {
    return (
        <div>
            <Navbar/>
            <h1 style = {{textAlign: 'center', marginTop: '100px'}}>Register a Clinic</h1>
            <p style = {{textAlign: 'center', marginTop: '10px'}}>Thank you for your interest in registering your clinic with KC Social Nest. After submitting, our team will look at the details and implement them into the database.</p>
            
            {/* Information Form */}
            <div style = {{display: 'flex', flexWrap: 'wrap', columnGap: '40px', rowGap: '20px', marginTop: '100px', justifyContent: 'center', maxWidth: '500px', width: '95vw', marginLeft: 'auto', marginRight: 'auto', paddingBottom: '100px'}}>
                <div>
                    <p>Contact First Name</p>
                    <TextField inputId = "fname" placeholder = "John" width = "200px"/>
                </div>
                <div>
                    <p>Contact Last Name</p>
                    <TextField inputId = "lname" placeholder = "Doe" width = "200px"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Email Address</p>
                    <TextField inputId = "email" placeholder = "john.doe@mail.com" width = "100%" maxWidth = "100%"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Clinic Name</p>
                    <TextField inputId = "clinic-name" placeholder = "Soar High Healthcare" width = "100%" maxWidth = "100%"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Clinic Website</p>
                    <TextField inputId = "clinic-website" placeholder = "www.clinic.com" width = "100%" maxWidth = "100%"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Purpose</p>
                    <TextArea inputId = "purpose" placeholder = "Providing food to people in need" width = "100%" maxWidth = "100%"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Languages Served</p>
                    <TextArea inputId = "languages" placeholder = "English, Spanish, etc." width = "100%" maxWidth = "100%"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Eligibility Requirements</p>
                    <TextArea inputId = "eligibility" placeholder = "Must be U.S. Citizen, 18 yrs or older" width = "100%" maxWidth = "100%"/>
                </div>
                <div style = {{width: "440px", boxSizing: "border-box"}}>
                    <p>Documents Needed</p>
                    <TextArea inputId = "documents" placeholder = "Birth certificate, proof of health insurance" width = "100%" maxWidth = "100%"/>
                </div>
                <Button text = "Submit" width = "100%" maxWidth = "440px" onClick = {submitClinic}/>
            </div>
            <Footer/>
        </div>
    )
}